export default __webpack_public_path__ + "static/media/TRX.e81b67cb.png";